import Button from "../base/Button";

const renderIcon = (color) => (
    <svg width="33px" height="31px" viewBox="0 0 33 31" version="1.1">
        <title>highlight</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g
            id="Symbols---Zep"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g id="LS-Menu" transform="translate(-527.000000, -15.000000)">
                <g id="highlight">
                    <g transform="translate(527.500000, 14.000000)">
                        <polyline
                            id="Shape"
                            stroke={color}
                            strokeLinecap="square"
                            points="9.9047619 26.6666667 5.33333333 31.2380952 0.761904762 29.7142857 6.85714286 23.6190476"
                        />
                        <rect
                            id="Rectangle-path"
                            fill={color}
                            fillRule="nonzero"
                            transform="translate(22.094395, 11.429263) rotate(-45.000000) translate(-22.094395, -11.429263) "
                            x="15.6296947"
                            y="9.27461655"
                            width="12.9293998"
                            height="4.30929201"
                        />
                        <rect
                            id="Rectangle-path"
                            stroke={color}
                            strokeWidth="0.99999041"
                            strokeLinecap="square"
                            transform="translate(17.523505, 15.998923) rotate(-45.000000) translate(-17.523505, -15.998923) "
                            x="4.59334305"
                            y="9.53422261"
                            width="25.8603234"
                            height="12.9293998"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

/**
 * Toolbar button for the highlight tool.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered highlight button.
 */
const HighlightButton = (props) => (
    <Button {...props} renderIcon={renderIcon} />
);

export default HighlightButton;
